module.exports = __webpack_public_path__ + "static/media/im10.a0d534ab.png";